import { z } from 'zod';
import { AttachmentSchema } from './attachments.js';

// Derived from AttachmentSchema — omits `uploadedAt` (not needed by the ZIP builder, REQ-9.4).
// Adding a new fileType to AttachmentSchema automatically flows through here.
const ManifestAttachmentSchema = AttachmentSchema.omit({ uploadedAt: true });

const ManifestUnitSchema = z.object({
  unitId: z.number(),
  grwId: z.string(),
  city: z.string(),
  address: z.string(),
  attachments: z.array(ManifestAttachmentSchema),
});

/** Maximum number of unit IDs accepted per bulk-download request. Exported so UI guards stay in sync. */
export const BULK_DOWNLOAD_MAX_UNITS = 200;

/** Request schema for the bulk attachment download manifest endpoint. Covers REQ-9.4. */
export const BulkDownloadManifestRequestSchema = z.object({
  unitIds: z.array(z.number().int().positive()).min(1).max(BULK_DOWNLOAD_MAX_UNITS),
});

export type BulkDownloadManifestRequest = z.infer<typeof BulkDownloadManifestRequestSchema>;

/** Response schema for the bulk attachment download manifest endpoint. Covers REQ-9.4. */
export const BulkDownloadManifestResponseSchema = z.object({
  units: z.array(ManifestUnitSchema),
  totalFiles: z.number(),
  totalBytes: z.number(),
  unitsWithoutAttachments: z.array(z.object({ unitId: z.number(), grwId: z.string() })),
});

export type BulkDownloadManifestResponse = z.infer<typeof BulkDownloadManifestResponseSchema>;
